import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=2a934b38&scoped=true&"
import script from "./AuthView.vue?vue&type=script&lang=js&"
export * from "./AuthView.vue?vue&type=script&lang=js&"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=2a934b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a934b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a934b38')) {
      api.createRecord('2a934b38', component.options)
    } else {
      api.reload('2a934b38', component.options)
    }
    module.hot.accept("./AuthView.vue?vue&type=template&id=2a934b38&scoped=true&", function () {
      api.rerender('2a934b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/AuthView.vue"
export default component.exports